<!--
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-10-08 09:46:38
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-10-08 14:30:37
 * @FilePath: /streamline_detail/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <Home></Home>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import Home from '@/views/home/home'

export default defineComponent({
  components: { Home },
  setup() {}
})
</script>

<style lang="scss">
@import '@zz/sasscore/reset.scss';

#app {
  overflow: hidden;
}
</style>
